var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeicarIsotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 126,
    viewBox: "0 0 221 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120.265 44.3281C112.329 19.6081 89.0594 1.79759 61.7043 2.18632C28.5128 2.65718 1.66497 30.3009 2.00316 63.6168C2.33589 96.9163 29.331 123.81 62.5879 123.81C77.31 123.81 91.2794 119.079 101.305 109.772C128.104 84.904 203.176 4.81436 203.176 4.81436C208.947 -1.13159 219 2.96926 219 11.275V126",
    stroke: "url(#paint0_linear_37_290)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_290",
    x1: 2,
    y1: 64.5905,
    x2: 219,
    y2: 64.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B8DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeicarIsotype);
export default __webpack_public_path__ + "static/media/peicar-isotype.531b6570a3a79e57571ef58045204aaa.svg";
export { ForwardRef as ReactComponent };